/**
 * The property carrying a record's runtime identity.
 *
 * <p>Required in every generated record schema so a PATCH can address the row, and never rendered:
 * it is what the row IS, not something anyone answers about it.
 *
 * <p>Its own module, with no imports, because the utilities that need it — the record readers, the
 * field counter, the outstanding-fields walk — are themselves dependencies of the section registry.
 * Declaring it there made the registry import its own dependants and the cycle surfaced as
 * "Cannot access '__vite_ssr_import_0__' before initialization" from an unrelated suite.
 */
export const RECORD_ID_PROPERTY = "record_id" as const;
